import request from '../utils/http'
const appid = 2001  // 维应SPR海外版

// 获取商品权限管理 302
export function getShopConfig(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_enum_price',
            ...data
        }
    })
}

// 根据成本价计算溢价后的零售价 305
export function getShopCbPrice(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'computeprice',
            ...data
        }
    })
}

// 根据成本价计算溢价后的团购价 307
export function getShopTuanPrice(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'tuanprice',
            ...data
        }
    })
}

// 物流费用 103
export function getLogistics (data) {
    return request({
        url: '/service/shop.ashx',
        params: {
            Method: 'runrule',
            ...data
        }
    })
  }

// 商品&零售物流信息添加-修改 352
export function addShopLogistics(data) {
    return request({
        url: '/service/commodity.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'runruleadd',
            ...data
        }
    })
}

// 商品&零售物流信息添加-修改 353
export function editShopLogistics(data) {
    return request({
        url: '/service/commodity.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'runruleedit',
            ...data
        }
    })
}

// 商品&零售物流信息-列表 354
export function getShopLogisticsList(data) {
    return request({
        url: '/service/commodity.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'runrulelist',
            ...data
        }
    })
}

// 商品&批发物流信息添加-修改 375
export function addShopPfLogistics(data) {
    return request({
        url: '/service/commodity.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'runruleadd2',
            ...data
        }
    })
}

// 商品&零售物流信息添加-修改 376
export function editShopPfLogistics(data) {
    return request({
        url: '/service/commodity.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'runruleedit2',
            ...data
        }
    })
}

// 商品&零售物流信息-列表 377
export function getShopPfLogisticsList(data) {
    return request({
        url: '/service/commodity.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'runrulelist2',
            ...data
        }
    })
}

// 提交订单 67
export function addOrder(data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'addorder_mul',
            ...data
        }
    })
}

// 销售业务-提交订单 474
export function addXsOrder(data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'addorder_ordertype43',
            ...data
        }
    })
}

// 订单列表 479
export function getOrderListWeb(data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'myorder_web',
            ...data
        }
    })
}

// 订单列表 61 \ 15
export function getOrderList(data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'myorder_mul',
            ...data
        }
    })
}

// 获取订单详情 63
export function getOrderListDetail(data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'myorderview',
            ...data
        }
    })
}

// 发货&物流管理-列表  358
export function getLogisticsList(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservicelist',
            ...data
        }
    })
}

// 发货&物流管理-明细  359
export function getLogisticsDetail(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlserviceview',
            ...data
        }
    })
}

// 发货&物流管理-修改  360
export function editLogistics(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "post",  //接口方法
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data,
    })
}

// 发货&物流管理-仓库配货管理-新增  361
export function addLogisticsDis(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_ordergoodsadd',
            ...data
        }
    })
}

// 发货&物流管理-仓库配货管理-修改  362
export function editLogisticsDis(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_ordergoodsedit',
            ...data
        }
    })
}

// 发货&物流管理-仓库配货管理-列表  363
export function getLogisticsDisList(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_ordergoodslist',
            ...data
        }
    })
}

// 发货&物流管理-仓库配货管理-详情  364
export function getLogisticsDisDetail(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_ordergoodsview',
            ...data
        }
    })
}

// 获取商品图片-二维码携带参数 402
export function getShopErcodeImg(data) {
    return request({
        url: '/service/commodity_ercode.ashx',
        method: "get",  //接口方法
        params: {
            cmid: data
        }
    })
}

// 库存变动原因 246
export function getShopBasenumReason(data) {
    return request({
        url: '/service/commodity.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_basenum_reason',
            ...data
        }
    })
}

// 获取某个商品下的库存信息 404
export function getShopWarehouse(data) {
    return request({
        url: '/service/wlservice.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getmsg',
            ...data
        }
    })
}

// 商品配件列表 405
export function getShopAttachmentList(data) {
    return request({
        url: '/service/view/ams_shop_commodity_pei_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_peilist',
            ...data
        }
    })
}

// 商品配件详情 406
export function getShopAttachmentDetail(data) {
    return request({
        url: '/service/view/ams_shop_commodity_pei_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_peiview',
            ...data
        }
    })
}

// 新增商品配件 408
export function addShopAttachmentl(data) {
    return request({
        url: '/service/view/ams_shop_commodity_pei_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_peiadd',
            ...data
        }
    })
}

// 修改商品配件 409
export function editShopAttachmentl(data) {
    return request({
        url: '/service/view/ams_shop_commodity_pei_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_peiedit',
            ...data
        }
    })
}

// 商品细分库存记录表 -410
export function getShopInventoryRecordList(data) {
    return request({
        url: '/service/view/ams_shop_commodity_basenum_sum_detail_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_basenum_sum_detaillist',
            ...data
        }
    })
}

// 退费列表 420
export function getBacklogList(data) {
    return request({
        url: '/service/view/ams_shop_backlog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_backlogpage',
            ...data,
        }
    })
}

// 退费详情 421
export function getBacklogDetail(data) {
    return request({
        url: '/service/view/ams_shop_backlog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_backlogview',
            ...data
        }
    })
}

// 退费详情 465
export function editBacklogState(data) {
    return request({
        url: '/service/view/ams_shop_backlog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_backlogedit',
            ...data
        }
    })
}

// 门店活动列表 429
export function getActivityList(data) {
    return request({
        url: '/service/view/ams_shop_activity_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activitypage',
            ...data
        }
    })
}

// 门店活动新增 430
export function addActivity(data) {
    return request({
        url: '/service/view/ams_shop_activity_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activityadd',
            ...data,
            // appid
        }
    })
}

// 门店活动修改 431
export function editActivity(data) {
    return request({
        url: '/service/view/ams_shop_activity_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activityedit',
            ...data,
            // appid
        }
    })
}

// 门店活动详情 432
export function getActivityDetail(data) {
    return request({
        url: '/service/view/ams_shop_activity_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activityview',
            ...data,
            appid
        }
    })
}

// 活动banner列表 433
export function getActivityBannerList(data) {
    return request({
        url: '/service/view/ams_shop_activity_banner_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_bannerlist',
            ...data,
        }
    })
}

// 活动banner新增 434
export function addActivityBanner(data) {
    return request({
        url: '/service/view/ams_shop_activity_banner_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_banneradd',
            ...data,
        }
    })
}

// 活动banner修改 435
export function editActivityBanner(data) {
    return request({
        url: '/service/view/ams_shop_activity_banner_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_banneredit',
            ...data,
        }
    })
}

// 活动banner详情 436
export function getActivityBannerDetail(data) {
    return request({
        url: '/service/view/ams_shop_activity_banner_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_bannerview',
            ...data,
        }
    })
}

// 新增参加活动 437
export function addActivityLogList(data) {
    return request({
        url: '/service/view/ams_shop_activity_log_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_logadd',
            ...data,
        }
    })
}

// 参加活动列表 438
export function getActivityLogList(data) {
    return request({
        url: '/service/view/ams_shop_activity_log_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_logpage',
            ...data,
        }
    })
}

// 活动详情列表 440
export function getActivityDetailList(data) {
    return request({
        url: '/service/view/ams_shop_activity_videopic_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_videopiclist',
            ...data,
        }
    })
}

// 活动详情新增 334
export function addActivityDetail(data) {
    return request({
        url: '/service/view/ams_shop_activity_videopic_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_videopicadd',
            ...data,
        }
    })
}
// 活动详情修改 335
export function editActivityDetail(data) {
    return request({
        url: '/service/view/ams_shop_activity_videopic_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_videopicedit',
            ...data,
        }
    })
}

// 活动详情详情 336
export function getActivityDetailDetail(data) {
    return request({
        url: '/service/view/ams_shop_activity_videopic_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_videopicview',
            ...data,
        }
    })
}

// 活动详情删除 449
export function delActivityDetailDetail(data) {
    return request({
        url: '/service/view/ams_shop_activity_videopic_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_activity_videopicdel',
            ...data,
        }
    })
}

// 订单支付收款-列表 480
export function getOrderPaymentList(data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpayloglist',
            ...data,
        }
    })
}

// 订单支付收款-详情 481
export function getOrderPaymentDetail(data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpaylogview',
            ...data,
        }
    })
}

// 订单支付收款-新增 482
export function addOrderPayment(data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpaylogadd',
            ...data,
        }
    })
}

// 订单支付收款-修改 483
export function editOrderPayment(data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpaylogedit',
            ...data,
        }
    })
}

// 修改订单审核状态 484
export function editOrderCheck(data) {
    return request({
        url: '/service/view/order.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_orderedit',
            ...data,
        }
    })
}

// 查看商品多币种价格 486
export function getShopMultiPrice(data) {
    return request({
        url: '/service/view/order.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getview',
            ...data,
        }
    })
}

// 新增商品多币种价格 491
export function addShopMultiPrice(data) {
    return request({
        url: '/service/view/ams_shop_commodity_exrate_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_exrateadd',
            ...data,
        }
    })
}

// 修改商品多币种价格 491
export function editShopMultiPrice(data) {
    return request({
        url: '/service/view/ams_shop_commodity_exrate_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_exrateedit',
            ...data,
        }
    })
}

// 核算商品多币种价格 485
export function accountShopMultiPrice(data) {
    return request({
        url: '/service/view/order.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'sync',
            ...data,
        }
    })
}

// 商品生产组码-列表 469
export function getShopProductionCode(data) {
    return request({
        url: '/service/view/ams_shop_commodity_groupma_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_groupmapage',
            ...data,
        }
    })
}

// 商品生产组码-详情 472
export function getShopProductionCodeDetail(data) {
    return request({
        url: '/service/view/ams_shop_commodity_groupma_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_groupmaview',
            ...data,
        }
    })
}

// 商品生产组码-新增 470
export function addShopProductionCode(data) {
    return request({
        url: '/service/view/ams_shop_commodity_groupma_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_groupmaadd',
            ...data,
        }
    })
}

// 商品生产组码-新增 471
export function editShopProductionCode(data) {
    return request({
        url: '/service/view/ams_shop_commodity_groupma_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_groupmaedit',
            ...data,
        }
    })
}

// 汇率参数列表 521
export function getExrateList() {
    return request({
        url: '/service/view/ams_shop_exrate_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_exratelist',
        }
    })
}

// 475 商品详情查看-英越俄泰语
export function getLanguageShopDetail(data) {
    return request({
        url: '/service/lan/cm_detail.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_base_view',
            ...data
        }
    })
}

// 476 商品详情新增-英越俄泰语
export function addLanguageShopDetail(data) {
    return request({
        url: '/service/lan/cm_detail.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'videopicadd',
            ...data
        }
    })
}

// 477 商品详情修改-英越俄泰语
export function editLanguageShopDetail(data) {
    return request({
        url: '/service/lan/cm_detail.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'videopicedit',
            ...data
        }
    })
}

// 478 商品详情删除-英越俄泰语
export function delLanguageShopDetail(data) {
    return request({
        url: '/service/lan/cm_detail.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'videopicdel',
            ...data
        }
    })
}

// 538 修改物流订单
export function wlserviceedit(data) {
    return request({
        url: '/service/view/ams_shop_wlservice_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlserviceedit',
            ...data
        }
    })
}

// 539 订单商品独立发货管理-列表
export function getShopWlserviceList(data) {
    return request({
        url: '/service/view/ams_shop_wlservice_sendtype_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_sendtypelist',
            ...data
        }
    })
}

// 540 订单商品独立发货管理-新增
export function addShopWlservice(data) {
    return request({
        url: '/service/view/ams_shop_wlservice_sendtype_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_sendtypeadd',
            ...data
        }
    })
}

// 541 订单商品独立发货管理-修改
export function editShopWlservice(data) {
    return request({
        url: '/service/view/ams_shop_wlservice_sendtype_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_sendtypeedit',
            ...data
        }
    })
}

// 542 订单商品独立发货管理-详情
export function getShopWlserviceDetail(data) {
    return request({
        url: '/service/view/ams_shop_wlservice_sendtype_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_wlservice_sendtypeview',
            ...data
        }
    })
}

// 519 订单来源-列表
export function getOrderChannelList(data) {
    return request({
        url: '/service/view/ams_shop_order_channel_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_channellist',
            ...data
        }
    })
}

// 543 提交订单-第三方零售渠道订单登记
export function addLsOrder(data) {
    return request({
        url: '/service/shop.ashx',
        method: "post",  //接口方法
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' },
        // data
        params: {
            Method: 'addorder_ordertype60',
            ...data
        }
    })
}

// 576 商品属性标签管理-列表
export function getShopCommodityAttr(data) {
    return request({
        url: '/service/view02/ams_shop_commodity_attr_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_attrpage',
            ...data
        }
    })
}

// 577 商品属性标签管理-新增
export function addShopCommodityAttr(data) {
    return request({
        url: '/service/view02/ams_shop_commodity_attr_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_attradd',
            ...data
        }
    })
}

// 578 商品属性标签管理-修改
export function editShopCommodityAttr(data) {
    return request({
        url: '/service/view02/ams_shop_commodity_attr_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_attredit',
            ...data
        }
    })
}

// 579 商品属性标签管理-查看
export function getShopCommodityAttrView(data) {
    return request({
        url: '/service/view02/ams_shop_commodity_attr_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_attrview',
            ...data
        }
    })
}

// 552 获取介绍人名下-用户的订单
export function getFriendOrder(data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'myfriends_order',
            ...data
        }
    })
}

// 642 商品选款情报列表
export function getShopSelectMsgList(data) {
    return request({
        url: '/service/view03/ams_shop_commodity_SelectMsg_Hand.ashx',
        method: "get",  //接口方法
        params: {
            method: 'ams_shop_commodity_SelMsgpage',
            ...data
        }
    })
}

// 643 商品选款情报添加
export function addShopSelectMsg(data) {
    return request({
        url: '/service/view03/ams_shop_commodity_SelectMsg_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_SelMsgadd',
            ...data
        }
    })
}

// 644 商品选款情报修改
export function editShopSelectMsg(data) {
    return request({
        url: '/service/view03/ams_shop_commodity_SelectMsg_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_SelMsgedit',
            ...data
        }
    })
}

// 645 商品选款情报查看
export function getShopSelectMsgDetail (data) {
    return request({
        url: '/service/view03/ams_shop_commodity_SelectMsg_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_commodity_SelMsgview',
            ...data
        }
    })
}

// 480 订单支付收款-列表
export function getOrderPayList (data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpaylogpage',
            // Method: 'ams_shop_order_mulpayloglist',
            ...data
        }
    })
}

// 481 订单支付收款-详情
export function getOrderPayDetail (data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpaylogview',
            ...data
        }
    })
}

// 482 订单支付收款-添加
export function addOrderPayLog (data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpaylogadd',
            ...data
        }
    })
}

// 483 订单支付收款-修改
export function editOrderPayLog (data) {
    return request({
        url: '/service/view/ams_shop_order_mulpaylog_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_order_mulpaylogedit',
            ...data
        }
    })
}

// 16 确认收货接口
export function getSubmitShop (data) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'submitget',
            ...data
        }
    })
}